export const SET_LANGUAGE = 'SET_LANGUAGE'

export function setLanguage(code) {
    return {
      type: SET_LANGUAGE,
      payload: code,
    }
  }